// Mock data for Savior Windows

export const contactInfo = {
  phone: "(720) 298-9993",
  phoneRaw: "7202989993",
  email: "info@saviorwindow.com",
  address: "6105 S. Main St STE 200",
  city: "Aurora",
  state: "CO",
  zip: "80016",
  hours: {
    weekday: "Monday - Friday: 8:00 AM - 6:00 PM",
    saturday: "Saturday: 9:00 AM - 4:00 PM",
    sunday: "Sunday: Closed"
  }
};

export const services = [
  {
    id: 1,
    title: "Window Replacement",
    description: "Energy-efficient windows that reduce heating and cooling costs while enhancing your home's curb appeal. Available in multiple styles and colors.",
    features: ["Energy Star certified", "Lifetime warranty", "Low maintenance", "Custom sizing"],
    icon: "home"
  },
  {
    id: 2,
    title: "Patio Door Installation",
    description: "Beautiful sliding and French patio doors that bring natural light into your home while providing seamless access to outdoor spaces.",
    features: ["Multi-point locking systems", "Energy-efficient glass", "Smooth operation", "Weather-resistant"],
    icon: "door-open"
  },
  {
    id: 3,
    title: "Entry Door Replacement",
    description: "Secure, stylish entry doors that make a lasting first impression. Choose from fiberglass, steel, or wood options.",
    features: ["Enhanced security", "Custom designs", "Weather sealing", "Energy efficient"],
    icon: "shield"
  },
  {
    id: 4,
    title: "Bay & Bow Windows",
    description: "Elegant bay and bow windows that expand your living space and create stunning focal points in any room.",
    features: ["Panoramic views", "Additional seating space", "Architectural beauty", "Natural light"],
    icon: "square"
  },
  {
    id: 5,
    title: "Glass Replacement",
    description: "Expert glass replacement for broken or damaged windows. Restore clarity and energy efficiency by replacing failed seals and foggy glass without full window replacement.",
    features: ["Broken glass repair", "Failed seal restoration", "Fog and condensation removal", "Energy efficiency restored"],
    icon: "sparkles"
  },
  {
    id: 6,
    title: "Repairs and Parts",
    description: "Professional repair services and genuine replacement parts for all window and door systems. We restore functionality and extend the life of your existing windows and doors.",
    features: ["Restoring operation", "Expert knowledge", "Genuine OEM parts", "Cost-effective solutions"],
    icon: "wrench"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Colorado Springs, CO",
    rating: 5,
    text: "Savior Windows exceeded all our expectations! They replaced 12 windows in our home and the difference in energy efficiency is remarkable. Our heating bill dropped significantly this winter. The crew was professional, clean, and completed the job in two days.",
    date: "March 2024"
  },
  {
    id: 2,
    name: "Robert & Linda Chen",
    location: "Denver, CO",
    rating: 5,
    text: "We've worked with several contractors over the years, but Savior Windows stands out. They helped us choose the perfect patio door and the installation was flawless. It's been a year and we couldn't be happier with the quality and performance.",
    date: "January 2024"
  },
  {
    id: 3,
    name: "Michael Torres",
    location: "Aurora, CO",
    rating: 5,
    text: "From quote to completion, everything was handled professionally. The team answered all our questions, stayed on schedule, and cleaned up perfectly each day. Our new bay window is absolutely stunning and has transformed our living room.",
    date: "February 2024"
  },
  {
    id: 4,
    name: "Jennifer Adams",
    location: "Fort Collins, CO",
    rating: 5,
    text: "After getting quotes from four different companies, Savior offered the best value without compromising quality. They replaced our entry door and four windows. The craftsmanship is excellent and the warranty gives us peace of mind.",
    date: "December 2023"
  },
  {
    id: 5,
    name: "David & Patricia Brown",
    location: "Boulder, CO",
    rating: 5,
    text: "We appreciated the transparent pricing and no-pressure sales approach. The installation team was respectful of our home and incredibly skilled. Our new windows look beautiful and we've already noticed reduced outside noise.",
    date: "November 2023"
  }
];

export const stats = [
  { id: 1, value: "10+", label: "Years of Excellence" },
  { id: 2, value: "5000+", label: "Happy Homeowners" },
  { id: 3, value: "100%", label: "Satisfaction Rate" },
  { id: 4, value: "HEPA", label: "Clean Installation" }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Craftsmanship",
    description: "Over a decade of specialized experience in window and door installation across Colorado.",
    icon: "award"
  },
  {
    id: 2,
    title: "Quality Products",
    description: "We partner with industry-leading manufacturers to provide durable, energy-efficient products.",
    icon: "check-circle"
  },
  {
    id: 3,
    title: "Affordable Excellence",
    description: "Premium quality doesn't have to break the bank. We offer competitive pricing and flexible financing.",
    icon: "dollar-sign"
  },
  {
    id: 4,
    title: "Lifetime Warranty",
    description: "Stand behind our work with comprehensive warranties on both products and installation.",
    icon: "shield-check"
  },
  {
    id: 5,
    title: "Local Expertise",
    description: "Colorado-based team that understands local climate challenges and building requirements.",
    icon: "map-pin"
  },
  {
    id: 6,
    title: "HEPA Clean Installation",
    description: "Industry-leading air quality protection with portable HEPA filters during every window installation. We protect your family from dust and debris.",
    icon: "sparkles"
  }
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=800&q=80",
  "https://images.unsplash.com/photo-1614607242094-b1b2369010f4?w=800&q=80",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
  "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80",
  "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80"
];

export const financingOptions = [
  {
    id: 1,
    title: "12 Months Same as Cash",
    description: "No interest if paid in full within 12 months",
    terms: "Subject to credit approval"
  },
  {
    id: 2,
    title: "Extended Payment Plans",
    description: "Low monthly payments up to 60 months",
    terms: "Flexible terms available"
  },
  {
    id: 3,
    title: "Special Promotions",
    description: "Seasonal offers and military/senior discounts",
    terms: "Ask about current promotions"
  }
];
